import React from 'react';

const Tooltip = ({ text, disabled, children, styles = {} }) => {
  if (disabled) return children;
  return (
    <div
      className="tooltip"
      style={{
        position: 'relative',
        display: 'inline-block',
        opacity: 1,
      }}
    >
      <style>
        {`
        .tooltip:hover .tooltiptext {
          visibility: visible !important;
        }
        `}
      </style>
      {children}
      <span
        className="tooltiptext"
        style={{
          visibility: 'hidden',
          width: 160,
          backgroundColor: 'black',
          color: '#fff',
          textAlign: 'center',
          padding: 4,
          borderRadius: 6,
          left: -160,
          position: 'absolute',
          zIndex: 1,
          ...styles,
        }}
      >
        {text}
      </span>
    </div>
  );
};

export default Tooltip;
